import { render, staticRenderFns } from "./ForumChatThreadCardIndicators.vue?vue&type=template&id=165e1234&scoped=true"
import script from "./ForumChatThreadCardIndicators.vue?vue&type=script&lang=js"
export * from "./ForumChatThreadCardIndicators.vue?vue&type=script&lang=js"
import style0 from "./ForumChatThreadCardIndicators.vue?vue&type=style&index=0&id=165e1234&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165e1234",
  null
  
)

export default component.exports